import React from 'react';
import styled, { css } from 'styled-components'; 

import closeIcon from 'images/icon/close_icon-28x29.png'

export default function VerticalBtnCenterModal({
    visible,
    dataList,
    btnList,
    setInitModal,
    zIndex, 
    showCloseBtn=false,
    showKakaoChatBtn=false
}) {
    if(!visible) return null;
    return (
        dataList && btnList.length !== 0 ? (
            <FullScreen zIndex={zIndex}>
                <WhiteBox>
                    <ModalTop>
                        {showCloseBtn && (
                            <CloseBtnBlock>
                                <CloseBtn onClick={() => setInitModal(true)}>
                                    <Image src={closeIcon}/>
                                </CloseBtn>
                            </CloseBtnBlock>
                        )}
                        {dataList?.image ? (
                            <ImageBlock>
                                <Image src={dataList.image}/>
                            </ImageBlock>
                        ) : null}
                        <TitleBlock>
                            <Title>{dataList.title}</Title>
                        </TitleBlock>
                        <DescriptionBlock>
                            <Description>{dataList.description}</Description>
                        </DescriptionBlock>
                    </ModalTop>
                    <ButtonBlock>
                        {btnList.map((data, index) => {
                            return <CompleteButton key={index} style={data.wrapperStyle} onClick={data.onAction}>{data.text}</CompleteButton>;
                        })}
                        {(showKakaoChatBtn === true) && (
                            <KakaoChatWrapper>
                                <KakaoChatLink target='_blank' href={'http://pf.kakao.com/_gmtJs/chat'}>
                                    카카오 문의하기
                                </KakaoChatLink>
                            </KakaoChatWrapper>
                        )}
                    </ButtonBlock>
                </WhiteBox>
            </FullScreen>
        ) : null
    )
}

const FullScreen = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: ${({zIndex}) => zIndex ? zIndex : '400'};
`;

const WhiteBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: calc(100vw * (284 / 375));
    background: #fff;
    border-radius: 10px;
`;

const ModalTop = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-height: calc(100vw * (196 / 375));
    padding: calc(100vw * (17 / 375));
`;

const CloseBtnBlock = styled.div`
    width: 100%;
`;

const CloseBtn = styled.p`
    width: calc(100vw * (13 / 375));
    height: calc(100vw * (13 / 375));
`;

const ImageBlock = styled.div`
    width: calc(100vw * (76 / 375));
    height: calc(100vw * (76 / 375));
    padding-top: calc(100vw * (6 / 375));
    margin-bottom: calc(100vw * (9 / 375));
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const TitleBlock = styled.div`
    width: 100%;
    margin-top: calc(100vw * (10 / 375));
`;

const Title = styled.p`
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (29 / 375));
    white-space: pre-wrap;
    text-align: center;
`;

const DescriptionBlock = styled.div`
    width: 100%;
    margin-top: calc(100vw * (13 / 375));
`;

const Description = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (20 / 375));
    white-space: pre-wrap;
    text-align: center;
    color: #4E4E4E;
`;

const ButtonBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: calc(100vw * (5 / 375)) calc(100vw * (24 / 375)) calc(100vw * (10 / 375)) calc(100vw * (24 / 375));
`;

const buttonStyle = css`
    padding: calc(100vw * (14 / 375)) 0;
    width: 100%;
    border-radius: 8px;
    font-size: calc(100vw * (16 / 375));
    font-weight: 500;
    line-height: calc(100vw * (24 / 375));
    margin-bottom: calc(100vw * (10 / 375));
`;

const CompleteButton = styled.button`
    ${buttonStyle};
    
`;

const KakaoChatWrapper = styled.div`
    text-align: center;
    margin: calc(100vw * (6 / 375)) 0 calc(100vw * (19 / 375)) 0;
`;

const KakaoChatLink = styled.a`
    font-size: calc(100vw * (12 / 375));
    text-decoration: underline;
    text-underline-position: under;
`;